module.exports = __webpack_public_path__ + "img/228.32159b81.png";